export const PERMISSIONS = Object.freeze({
  PRODUCT_SET_FIXED_BUMP: "product.set_fixed_bump",
  PRODUCT_CLEAR_FIXED_BUMP: "product.clear_fixed_bump",
});
